import { render, staticRenderFns } from "./ImportFileIcon.vue?vue&type=template&id=2ad47866"
import script from "./ImportFileIcon.js?vue&type=script&lang=js&external"
export * from "./ImportFileIcon.js?vue&type=script&lang=js&external"
import style0 from "./ImportFileIcon.vue?vue&type=style&index=0&id=2ad47866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports